import { debounce } from "lodash-es"
import { SolAds } from "./SolAdsClass"
import { soladsBottomPc } from "./templates"
import "./solads-styles.css"
import { isMobile } from "@modules/util/device"

const soladsOnWindowResizeDebounceMs = 200

let solAdsInstance: SolAds | null = null

export function rerenderSoladsPcBottom() {
    if (userData.hasAdFree || userData.isAgeVerified) {
        return
    }
    const pcsolads = document.querySelector("#page-closing-sol")
    if (pcsolads) {
        pcsolads.outerHTML = soladsBottomPc
    }
}

export function updateSolAdsSectors() {
    solAdsInstance?.updateSectors()
}

if (!userData.hasAdFree || !userData.isAgeVerified) {
    solAdsInstance = new SolAds()

    window.addEventListener("orientationchange", debounce(rerenderSoladsPcBottom, soladsOnWindowResizeDebounceMs))
    // DONT initiate an event listener on resize to rerender solads or exoclick on mobile
    // It will trigger on mobile when scrolling and the browser bar shows/hides. Which triggers a lot of rerenders while scrolling
    // alternative fix would be to check for width changes only.
    if (!isMobile()) {
        window.addEventListener("resize", debounce(rerenderSoladsPcBottom, soladsOnWindowResizeDebounceMs))
    }
}
